<div class="top">
  <div>
    <ng-content select="h1"></ng-content>
    <ng-content select="h2"></ng-content>
  </div>
  <a routerLink="/" class="start-link" *ngIf="showStartLink">Gå till start</a>
</div>

<ng-content select="p"></ng-content>
